module.exports = __webpack_public_path__ + "img/ឆ្នោត-2D.cd6c8145.png";